// CSS Modules - component class name: QuickAddBox__

<template>
  <div :class="$style.container">
    <div :class="$style.inner">
      <div v-if="config.boxTitle" :class="$style.textContainer">
        <i class="fas fa-cart-plus"></i>
        <span :class="$style.title">{{ config.boxTitle }}</span>
      </div>
      <div v-if="config.boxText" :class="$style.text">{{ config.boxText }}</div>
      <div
        :class="$style.quickAddPopper"
        v-tippy="{
          theme: 'wika light tooltip tooltip-bottom',
          interactive: true,
          reactive: true,
          placement: 'bottom',
          flip: false,
          animation: 'fade',
          duration: [200, 600],
          animateFill: false,
          arrow: true,
          distance: 7,
          zIndex: 10000,
          html: '#infoCircle',
          trigger: isMobileDevice ? 'click' : 'mouseenter focus'
        }"
        ref="tippy"
        @init="initTippy"
      >
        <i class="fas fa-info-circle"></i>
        <div
          id="infoCircle"
          v-html="
            `${config.infoPopperContent}<img src='${config.infoPopperImage}'>`
          "
        ></div>
      </div>
      <form @submit.prevent="">
        <div :class="$style.inputContainer">
          <template>
            <input
              :class="$style.inputField"
              type="text"
              v-model.trim="articleNumber"
              :placeholder="config.inputPlaceholder"
              @input="forceRerender"
              aria-label="article number"
              @keyup.enter="addItem"
            />
            <FormSelect
              :hasFilter="false"
              v-model="quantity"
              :options="selectOptions"
              :initialOption="quantity"
              @input="forceRerender"
              ariaLabel="article quantity"
            />
            <div
              :class="[
                $style.buttons,
                { QuickAddBox__buttonsHidden: checkingAvailability }
              ]"
            >
              <div :class="['Button__button', 'Button__blue', $style.infoBtn]">
                <a @click="checkAvailability">{{ config.infoButtonText }}</a>
              </div>
              <ShopCartLink
                :key="`cartLink1-${componentKey}`"
                :item="{
                  text: config.addButtonText,
                  quantity: quantity,
                  id: articleNumber,
                  headline: config.headline,
                  subheadline: config.subheadline,
                  pictureurl: config.pictureurl,
                  thumbnailurl: config.thumbnailurl,
                  producturl: config.producturl
                }"
                :addItemFailedMsg="config.addArticleFailedMessage"
                :addItemAmountMsgTxt="config.addItemAmountMsgTxt"
                :addItemHighestAmountMsg="config.addItemHighestAmountMessage"
                :addItemLowestAmountMsg="config.addItemLowestAmountMessage"
                :addItemMultipleAmountMsg="config.addItemMultipleAmountMessage"
                :addButtonLoadingText="config.addButtonLoadingText"
                :isDarkBackground="true"
                ref="addButton"
                @error="handleShopCartLinkError"
              />
              <div
                :class="[
                  $style.loadingBasket,
                  { QuickAddBox__loadingBasketVisible: checkingAvailability }
                ]"
              >
                <div :class="$style.loading">
                  <Loading :size="20" color="#fff" />
                </div>
                {{ config.loadingText }}
              </div>
            </div>
          </template>
        </div>
      </form>
      <Modal :isModalOpen="isModalOpen" @closeModal="closeModal">
        <div v-if="searchSuccess" :class="$style.modal">
          <p :class="$style.heading">
            {{ config.inputPlaceholder }}: {{ articleNumber }}
          </p>
          <div class="columns is-gapless">
            <div class="column is-two-thirds-tablet">
              <p :class="$style.subHeading">{{ config.articleDetails }}</p>
              <p
                v-if="data.Longtext"
                v-html="`${data.Longtext.replace(/(?:\r\n|\r|\n)/g, '<br>')}`"
              ></p>
              <p
                v-else
                v-html="`${data.Shorttext.replace(/(?:\r\n|\r|\n)/g, '<br>')}`"
              ></p>
            </div>
            <div class="column is-one-third-tablet">
              <div :class="$style.addToCart">
                <div :class="[$style.singlePrice, 'clearfix']">
                  <span :class="$style.label">
                    {{ config.pricePerItem }}:
                  </span>
                  <span :class="$style.label">{{ price }}</span>
                </div>
                <div :class="[$style.quantity, 'clearfix']">
                  <span :class="$style.label"> {{ config.quantity }}: </span>
                  <span :class="$style.label">
                    <FormSelect
                      :hasFilter="false"
                      v-model="quantity"
                      :options="selectOptions"
                      :initialOption="quantity"
                      @input="forceRerender"
                    />
                  </span>
                </div>
                <hr />
                <div :class="$style.sum" v-html="priceSum"></div>
                <div :class="$style.tax">
                  {{ config.tax }} &amp;
                  <a :href="config.shippingUrl">
                    {{ config.shippingText }}
                  </a>
                </div>
                <div
                  :class="[
                    {
                      QuickAddBox__deliveryStatusGreen:
                        data.DeliveryCategory === 1
                    },
                    {
                      QuickAddBox__deliveryStatusOrange:
                        data.DeliveryCategory === 2 ||
                        data.DeliveryCategoryValue === 3
                    }
                  ]"
                >
                  <span :class="$style.deliveryStatus"></span>
                  {{ deliveryCategory }},
                  {{ config.deliveryTime }}
                  {{ deliveryDays }}
                  {{ workDays }}
                </div>
                <div
                  :class="[
                    $style.buttons,
                    { QuickAddBox__buttonsHidden: checkingAvailability }
                  ]"
                >
                  <ShopCartLink
                    :key="`cartLink2-${componentKey}`"
                    :item="{
                      text: config.addButtonText,
                      quantity: quantity,
                      id: articleNumber,
                      headline: config.headline,
                      subheadline: config.subheadline,
                      pictureurl: config.pictureurl,
                      thumbnailurl: config.thumbnailurl,
                      producturl: config.producturl
                    }"
                    :addItemFailedMsg="config.addArticleFailedMessage"
                    :addItemHighestAmountMsg="
                      config.addItemHighestAmountMessage
                    "
                    :addItemLowestAmountMsg="config.addItemLowestAmountMessage"
                    :addItemMultipleAmountMsg="
                      config.addItemMultipleAmountMessage
                    "
                    :addButtonLoadingText="config.addButtonLoadingText"
                    @closed="closeModal"
                    :isDarkBackground="true"
                  />
                  <div
                    :class="[
                      $style.loadingBasket,
                      {
                        QuickAddBox__loadingBasketVisible: checkingAvailability
                      }
                    ]"
                  >
                    <div :class="$style.loading">
                      <Loading :size="30" />
                    </div>
                    {{ config.addButtonLoadingText }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else :class="$style.modal">
          <h4>{{ config.warningHeadline }}</h4>
          <p v-html="warningText" :class="$style.warningMessage" />
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { isMobile } from "mobile-device-detect";
import Modal from "../Modal/Modal";
import FormSelect from "../FormSelect/FormSelect";
import ShopCartLink from "../ShopCartLink/ShopCartLink";
import Loading from "../Loading/Loading";

export default {
  name: "QuickAddBox",
  components: {
    Modal,
    FormSelect,
    ShopCartLink,
    Loading
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      componentKey: 0,
      testing: false,
      isMobileDevice: isMobile,
      isModalOpen: false,
      searchSuccess: false,
      checkingAvailability: false,
      articleNumber: "",
      quantity: "1",
      data: {},
      price: "",
      deliveryDays: "",
      deliveryCategory: "",
      workDays: "",
      warningText: ""
    };
  },
  computed: {
    selectOptions: function() {
      const range = (start, end) =>
        [...Array(end - start + 1)].map((_, i) => start + i).map(String);
      return range(1, this.config.selectOptionMax);
    },
    priceSum: function() {
      const totalPrice = (this.data.PositionPrice * this.quantity)
        .toString()
        .replace(".", ",");
      return accounting.formatMoney(
        parseFloat(totalPrice.replace(".", "").replace(",", ".")),
        {
          symbol: this.config.currency,
          format: this.config.currencyPosition,
          decimal: this.config.decimalSep,
          thousand: this.config.thousandSep,
          precision: this.config.precisionValue
        }
      );
    }
  },
  methods: {
    addItem: function() {
      this.$refs.addButton && this.$refs.addButton.addItem();
    },
    forceRerender() {
      this.componentKey += 1;
    },
    initTippy(tippy) {
      tippy.popper.id = "quickAddPopper";
    },
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    checkAvailability() {
      this.checkingAvailability = true;
      const itemid = this.articleNumber;
      if (itemid && window.currentCountry && window.currentLanguage) {
        axios({
          url: window.getItemInfoUrl,
          method: "post",
          data: {
            itemid,
            country: window.currentCountry,
            language: window.currentLanguage
          }
        })
          .then(response => this.displaySuccessModal(response.data))
          // eslint-disable-next-line no-console
          .catch(error => console.log(error));
      } else {
        this.warningText = this.config.warningNoValueSubmitted;
        this.searchSuccess = false;
        this.isModalOpen = true;
        this.checkingAvailability = false;
      }
    },
    handleShopCartLinkError(data) {
      let { isArticleType, url } = data;

      if (isArticleType && url) {
        this.showArticleTypeUrl(url);
      }
    },
    showArticleTypeUrl(url) {
      this.warningText = this.config.warningIsArticleType.replace(
        /{(\w+( +\w+)*)}/,
        `<a href="${url}">$1</a>`
      );
      this.isModalOpen = true;
    },
    displaySuccessModal(data) {
      if (data.Success) {
        this.data = data;
        this.price = data.PositionPrice.toString().replace(".", ",");
        this.price = accounting.formatMoney(
          parseFloat(this.price.replace(".", "").replace(",", ".")),
          {
            symbol: this.config.currency,
            format: this.config.currencyPosition,
            decimal: this.config.decimalSep,
            thousand: this.config.thousandSep,
            precision: this.config.precisionValue
          }
        );
        this.deliveryDays =
          parseInt(data.DeliveryTime) + parseInt(this.config.externalTransport);
        if (data.DeliveryCategory === 1) {
          this.deliveryCategory = this.config.readyForShipping;
        } else if (data.DeliveryCategory > 1 && data.DeliveryCategory < 6) {
          this.deliveryCategory = this.config.deliveryAfterProduction;
        }
        data.DeliveryTime === 0
          ? (this.workDays = this.config.singularWorkDayStr)
          : (this.workDays = this.config.pluralWorkDayStr);
        this.searchSuccess = true;
        this.isModalOpen = true;
      } else if (data.IsArticleType && data.Url) {
        this.searchSuccess = false;
        this.showArticleTypeUrl(data.Url);
      } else {
        this.warningText = this.config.warningInvalidArticle;
        this.searchSuccess = false;
        this.isModalOpen = true;
      }
      this.checkingAvailability = false;
    },
    checkUrlForItemId() {
      const query = window.location.search.substring(1);
      const params = new URLSearchParams(query);
      const itemId = params.get("itemId");

      if (itemId) {
        this.articleNumber = itemId;
        this.checkAvailability();
      }
    }
  },
  mounted() {
    this.checkUrlForItemId();
  }
};
</script>

<style module lang="scss">
@import "./QuickAddBox.scss";
</style>
